import { ListItem } from '@tableau/widgets';
import { DisplayOptions } from './DisplayOptions';

export interface DisplaySelection {
  name: string;
  primaryDisplay: ListItem;
}

export namespace DisplayBy {
  export function getMixedViewDisplaySelection(): DisplaySelection {
    return {
      name: 'mixed view',
      primaryDisplay: DisplayOptions.getMixedView(),
    };
  }

  export function getListViewDisplaySelection(): DisplaySelection {
    return {
      name: 'list view',
      primaryDisplay: DisplayOptions.getListView(),
    };
  }
}
